import { useState, useEffect, useContext } from 'react';
import throttle from 'lodash/throttle';
import classNames from 'classnames';
import { StyleContext } from 'utils/context/StyleContextProvider';
import { BLOG_ARTICLES_STEP_LIMIT } from 'utils/constants';
import BlogArticle from './BlogArticle';

async function getStepBlogs(blogData, preview, slug) {
    const response = await fetch('/api/stepblogs', {
            method: 'post',
            body: JSON.stringify({
                len: blogData.blogs.length,
                preview,
                slug,
            }),
        }),
        blogs = await response.json();
    return blogs;
}

export default function BlogArticles({
    featuredBlogs = [],
    blogArticles = [],
    limit,
    skip = 0,
    preview = false,
    infinite = false,
    excludedBlogs = [],
    title,
    slug: newSlug,
    section = false,
}) {
    const styles = useContext(StyleContext),
        [slug, setSlug] = useState(newSlug),
        [blogData, setBlogData] = useState({
            blogs: blogArticles.blogs,
            limit,
            slug,
        }),
        [stopFetching, setStopFetching] = useState(false),
        footerMargin = 2000,
        handleScroll = throttle(
            async ({
                target: {
                    documentElement: { scrollHeight, scrollTop, clientHeight },
                },
            }) => {
                const totalScrollTop = scrollTop + footerMargin;
                if (scrollHeight - totalScrollTop <= clientHeight) {
                    getStepBlogs(blogData, preview, slug).then((blogs) => {
                        const blogItems = blogs.items;

                        if (blogItems.length !== BLOG_ARTICLES_STEP_LIMIT) {
                            setStopFetching(true);
                        }

                        setBlogData({
                            blogs: [...blogData.blogs, ...blogItems],
                            limit: blogData.blogs.length + blogItems.length,
                        });
                    });
                }
            },
            500,
        );

    if (infinite) {
        useEffect(() => {
            const removeListener = () => {
                window.removeEventListener('scroll', handleScroll);
            };
            if (stopFetching) {
                removeListener();
            } else {
                window.addEventListener('scroll', handleScroll);
            }

            return () => removeListener();
        }, [blogData, stopFetching]);
    }

    useEffect(() => {
        setSlug(blogArticles.slug);
        setBlogData({
            blogs: blogArticles.blogs,
            limit,
            slug,
        });
    }, [blogArticles]);

    return (
        <section
            className={classNames(
                styles.articles,
                `md:grid md:grid-cols-2 md:gap-15 lg:grid-cols-3 lg:gap-y-30`,
            )}
        >
            {title && (
                <p
                    className={classNames(
                        'heading-1 pb-10 lg:pb-2.5',
                        styles.title,
                    )}
                >
                    {title}
                </p>
            )}
            {featuredBlogs.map((blog) => (
                <BlogArticle blog={blog} key={blog.title} />
            ))}
            {blogData.blogs.slice(skip, blogData.limit + skip).map((blog) => {
                if (excludedBlogs.indexOf(blog.slug) > -1) {
                    return null;
                }
                return (
                    <BlogArticle
                        blog={blog}
                        key={blog.title}
                        section={section}
                    />
                );
            })}
        </section>
    );
}
